var app = angular.module("leonardo");

var OnDemandInstructionsList = function($scope, $state, OnDemandInstructionService, OnDemandCategoryService,
                                        OnDemandSubCategoryService, AccountUserService, FilterService,
                                        AuthDataService, ConfigThemeService, $timeout) {

  $scope.configThemeService = ConfigThemeService;
  $scope.list = [];
  $scope.listCategories = [];

  $scope.refresh = function() {
    var filters = {
      search: FilterService.getFilter('search'),
      client_instance: FilterService.getFilter('client_instances', true)
    };
    if (AuthDataService.isNotStaff()) {
      var account = null;
      if(AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.account){
        account = AccountUserService.currentAccountUser.account.id || AccountUserService.currentAccountUser.account;
      }
      if (isNull(account)) {
        account = FilterService.accounts.length > 0 ? FilterService.accounts[0].id : null;
      }
      filters['account'] = account;
    }
    OnDemandCategoryService.getlist(filters).then(function(list) {
      $scope.listCategories = list.results ? list.results : list;
      var valid_sub = [];
      angular.forEach($scope.listCategories, function(category) {
        angular.forEach(category.subcategories, function(subcategory) {
          if (!_.contains(valid_sub, subcategory.id)) {
            valid_sub.push(subcategory.id);
          }
        });
      });
      OnDemandSubCategoryService.getlist(filters).then(function(subCatlist) {
        $scope.listSubCategories = [];
        var results = subCatlist.results ? subCatlist.results : subCatlist;
        angular.forEach(results, function(subcategory) {
          if (!_.contains(valid_sub, subcategory.id)){
            $scope.listSubCategories.push(subcategory);
          }
        });
      });
    });
    OnDemandInstructionService.getlist(filters).then(function(inslist) {
      $scope.list = inslist.results ? inslist.results : inslist;
    });
  };

  $scope.toggleCategory = function(category) {
    $scope.categoryExpanded = ($scope.categoryExpanded === category) ? null : category;
  };

  $scope.categoryIsExpanded = function (group) {
    return ($scope.categoryExpanded === group);
  };

  $scope.goToItem = function(item) {
    $state.go('on-demand-instructions.instruction', {pk: item.id});
  };

  $scope.goToCategory = function(item) {
    $state.go('on-demand-instructions.category', {pk: item.id});
  };

  $scope.goToSubCategory = function(item, category) {
    $state.go('on-demand-instructions.subcategory', {pk: item.id, category:category ? category.id : null});
  };

  $scope.goToUnread = function (item) {
    $state.go('on-demand-instructions.unread', {pk: item.id});
  };

  $scope.$on('on-demand-instruction:updated', function(){
    $scope.refresh();
  });

  $scope.$on('filter-selection:updated', function(){
    $scope.refresh();
  });

  $timeout(function () {
    $scope.refresh();
  }, 0);

};

app.controller('OnDemandInstructionsList', ['$scope', '$state', 'OnDemandInstructionService', 'OnDemandCategoryService',
  'OnDemandSubCategoryService', 'AccountUserService', 'FilterService', 'AuthDataService', 'ConfigThemeService', '$timeout',
  OnDemandInstructionsList]);
